import { Guest } from '../../axios/pms/guests/types'
import {
	SET_ROOM_CHARGE_ERROR_CODE,
	SET_ROOM_CHARGE_GUESTS,
	SET_ROOM_CHARGE_GUESTS_ARE_LOADING,
	SET_ROOM_CHARGE_IS_PROCESSING,
	SET_ROOM_CHARGE_ORDER_ID,
} from '../../actionTypes/roomCharge'

export const setRoomChargeOrderId = (value: string | null) => ({ type: SET_ROOM_CHARGE_ORDER_ID, value })

export const setRoomChargeGuests = (value: Guest[]) => ({ type: SET_ROOM_CHARGE_GUESTS, value })

export const setRoomChargeGuestsAreLoading = (value: boolean) => ({ type: SET_ROOM_CHARGE_GUESTS_ARE_LOADING, value })

export const setRoomChargeIsProcessing = (value: boolean) => ({ type: SET_ROOM_CHARGE_IS_PROCESSING, value })

export const setRoomChargeErrorCode = (value: string | null) => ({ type: SET_ROOM_CHARGE_ERROR_CODE, value })
